import { default as i18n, InitOptions, ReactOptions } from "i18next";
import { default as HttpApi, BackendOptions } from "i18next-http-backend";
import moment from "moment";
import { initReactI18next } from "react-i18next";

const enableDebug = process.env.NODE_ENV !== "production";

const i18nOptions: InitOptions = {
  fallbackLng: "en",
  debug: enableDebug,
  interpolation: {
    escapeValue: false,
    format: function (value: any, format: string = "", lng: any = "") {
      if (moment.isDate(value) || moment.isMoment(value)) {
        let m = moment(value).clone();
        const specialLocalPrefix = "local ";
        if (format.startsWith(specialLocalPrefix)) {
          format = format.substring(specialLocalPrefix.length);
          m.local();
        }
        return m.format(format);
      }

      return value;
    },
  },
  fallbackNS: "translation",
};

const xhrOptions: BackendOptions = {
  loadPath: `${process.env.PUBLIC_URL}/translations/{{lng}}/{{ns}}.json`,
  crossDomain: false,
  withCredentials: false,
};

const i18nextSpecialOptions: { react: ReactOptions } = {
  react: {
    wait: true,
    bindI18n: "languageChanged loaded",
    nsMode: "default",
    useSuspense: false,
  },
};

i18n
  .use(HttpApi)
  .use(initReactI18next) // if not using I18nextProvider
  .on("languageChanged", (lng) => {
    moment.locale(lng);
  });

i18n.init({
  ...i18nOptions,
  ...i18nextSpecialOptions,
  backend: xhrOptions,
} as any);

export default i18n;
